import React from 'react'
import { Form, Row, Col, DropdownButton, Dropdown } from 'react-bootstrap'

// definitions
import { AccountXeroOrgWithData } from '../../../../screens/subsync/subsync'
import { XeroAPIContact } from '../../../../../../back-end/utilities/apiDefinitions'
import { DetailedStripeOrgAccountXeroOrg } from '../settings'

interface CreditNotesSettingsProps {
	orgMapping: DetailedStripeOrgAccountXeroOrg | undefined
	mappedXeroOrg: AccountXeroOrgWithData | undefined
	stripeOrgID: string
	handleSettingsUpdate: (stripeOrgID: string, values: { [name: string]: string | boolean | XeroAPIContact | undefined }) => void
}

const CreditNotesSettings = (props: CreditNotesSettingsProps) => {
	const [searchFilter, setSearchFilter] = React.useState<string>('')

	return (
		<>
			{props.orgMapping?.stripeOrgAccountXeroOrgProcessingType === 'Standard' && (
				<Form.Group as={Row} className="d-flex align-items-center" style={{ height: '2.5rem' }}>
					<Col sm="2">
						<Form.Label>Enable Credit Notes</Form.Label>
					</Col>
					<Col>
						<Form.Check
							type={'switch'}
							id={`${props.stripeOrgID}-credit-notes-enabled`}
							name={'creditNotesEnabled'}
							checked={!!props.orgMapping?.stripeOrgAccountXeroOrgSettings?.creditNotesEnabled}
							onChange={(e) => props.handleSettingsUpdate(props.stripeOrgID, { [e.target.name]: e.target.checked })}
						/>
					</Col>
				</Form.Group>
			)}
			<Form.Group as={Row} className="d-flex align-items-center" style={{ height: '2.5rem' }}>
				<Col sm="2">
					<Form.Label>Use chosen Xero Account for all credit notes</Form.Label>
				</Col>
				<Col>
					<Form.Check
						type={'switch'}
						id={`${props.stripeOrgID}-use-single-xero-account`}
						name={'creditNotesUseSingleXeroAccount'}
						checked={!!props.orgMapping?.stripeOrgAccountXeroOrgSettings?.creditNotesUseSingleXeroAccount}
						onChange={(e) => props.handleSettingsUpdate(props.stripeOrgID, { [e.target.name]: e.target.checked })}
						disabled={
							props.orgMapping?.stripeOrgAccountXeroOrgProcessingType === 'Standard' &&
							!props.orgMapping?.stripeOrgAccountXeroOrgSettings?.creditNotesEnabled
						}
					/>
				</Col>
			</Form.Group>
			<Form.Group as={Row}>
				<Col>
					{props.orgMapping?.stripeOrgAccountXeroOrgSettings?.creditNotesUseSingleXeroAccount
						? 'Choose an account to use for all credit notes:'
						: 'Choose an account to use for credit notes with custom line items:'}
				</Col>
			</Form.Group>
			<Form.Group as={Row} style={{ height: '2.5rem' }}>
				<Form.Label column sm={2}>
					Xero Account
				</Form.Label>
				<Col sm={4}>
					<DropdownButton
						id={`${props.stripeOrgID}-credit-notes-account-select`}
						title={
							props.mappedXeroOrg!.accounts.find(
								(a) => a.xeroAccountID === props.orgMapping?.stripeOrgAccountXeroOrgSettings?.creditNotesXeroAccountID
							)?.name || 'Select Xero Account'
						}
						onSelect={(eventKey) => props.handleSettingsUpdate(props.stripeOrgID, { creditNotesXeroAccountID: eventKey! })}
						disabled={
							props.orgMapping?.stripeOrgAccountXeroOrgProcessingType === 'Standard' &&
							!props.orgMapping?.stripeOrgAccountXeroOrgSettings?.creditNotesEnabled
						}
					>
						<Dropdown.Item as="div">
							<Form.Control
								type="text"
								placeholder="Search or enter value"
								value={searchFilter}
								onClick={(e: React.MouseEvent<HTMLInputElement>) => e.stopPropagation()} // Prevent dropdown from closing on input click
								onChange={(e: React.ChangeEvent<HTMLInputElement>) => setSearchFilter(e.target.value)} // Handle input changes
							/>
						</Dropdown.Item>
						<Dropdown.Header>Revenue</Dropdown.Header>
						{props
							.mappedXeroOrg!.accounts.filter(
								(account) => account.type === 'REVENUE' && account.name!.toLowerCase().includes(searchFilter.toLowerCase())
							)
							.sort((a, b) => a.name!.localeCompare(b.name!, undefined, { numeric: true }))
							.map((xa) => (
								<Dropdown.Item key={xa.xeroAccountID} eventKey={xa.xeroAccountID}>
									{xa.name}
								</Dropdown.Item>
							))}
						<Dropdown.Header>Other Income</Dropdown.Header>
						{props
							.mappedXeroOrg!.accounts.filter(
								(account) => account.type === 'OTHERINCOME' && account.name!.toLowerCase().includes(searchFilter.toLowerCase())
							)
							.sort((a, b) => a.name!.localeCompare(b.name!, undefined, { numeric: true }))
							.map((xa) => (
								<Dropdown.Item key={xa.xeroAccountID} eventKey={xa.xeroAccountID}>
									{xa.name}
								</Dropdown.Item>
							))}
						<Dropdown.Header>Sales</Dropdown.Header>
						{props
							.mappedXeroOrg!.accounts.filter(
								(account) => account.type === 'SALES' && account.name!.toLowerCase().includes(searchFilter.toLowerCase())
							)
							.sort((a, b) => a.name!.localeCompare(b.name!, undefined, { numeric: true }))
							.map((xa) => (
								<Dropdown.Item key={xa.xeroAccountID} eventKey={xa.xeroAccountID}>
									{xa.name}
								</Dropdown.Item>
							))}
						<Dropdown.Header>Current Liability</Dropdown.Header>
						{props
							.mappedXeroOrg!.accounts.filter(
								(account) => account.type === 'CURRLIAB' && account.name!.toLowerCase().includes(searchFilter.toLowerCase())
							)
							.sort((a, b) => a.name!.localeCompare(b.name!, undefined, { numeric: true }))
							.map((xa) => (
								<Dropdown.Item key={xa.xeroAccountID} eventKey={xa.xeroAccountID}>
									{xa.name}
								</Dropdown.Item>
							))}
					</DropdownButton>
				</Col>
			</Form.Group>
		</>
	)
}

export { CreditNotesSettings }
